import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "flush", "scrollable", "compact"];
import { forwardRef } from 'react';
import styled from 'foundations-theming/utils';
import { useCardContext } from './CardContext';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { m } from 'framer-motion';
import { jsx as _jsx } from "react/jsx-runtime";
export const StyledCardSection = styled(m.div)(({
  $flush,
  $scrollable,
  $compact,
  $cssStyles,
  theme: _theme
}) => {
  const theme = _theme;
  const spacing = $compact ? theme.space['600'] : theme.space['1000'];
  const paddingTop = spacing;
  const paddingBottom = $scrollable ? '0' : spacing;
  const paddingX = $flush ? '0' : spacing;
  const padding = `${paddingTop} ${paddingX} ${paddingBottom}`;
  return Object.assign({
    padding,
    borderRadius: 'inherit'
  }, $scrollable ? {
    flex: '1 1 auto',
    overflow: 'auto',
    paddingTop: '0',
    '&:last-child': {
      marginBottom: spacing
    },
    '& + &': {
      paddingTop: spacing
    }
  } : {
    '& ~ &': {
      paddingTop: '0'
    }
  }, $cssStyles);
});
export const CardSection = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      flush = false,
      scrollable = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const {
    compact,
    expanded
  } = useCardContext();
  return /*#__PURE__*/_jsx(StyledCardSection, Object.assign({}, domProps, {
    initial: false,
    animate: expanded ? 'open' : 'collapsed',
    variants: {
      open: {
        opacity: 1,
        height: 'auto'
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    transition: {
      duration: 0.2,
      ease: [0.42, 0, 0.58, 1]
    },
    ref: ref,
    $flush: flush,
    $compact: compact,
    $scrollable: scrollable,
    $cssStyles: cssStyles,
    children: children
  }));
});